import React, { Component, useState } from 'react'
import Breadcrumb from '../common/breadcrumb'
import { Helmet } from 'react-helmet'
import { useForm } from 'react-hook-form'
import backend from '../../api'
const Contact = (props) => {
  const { handleSubmit, register, errors, getValues } = useForm()
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitForm = async () => {
    const val = getValues();
    setIsSubmitting(true); 
    try {
      const response = await backend.post('/contactus', val);
      const { message } = response.data;
      console.log('Message:', message);
      // window.location.reload(); 
    } catch (err) {
      console.log(err);
    } finally {
      setIsSubmitting(false); 
    }
  };

  return (
    <div>
      <Helmet>
        <title>eksplode! | Contact</title>
      </Helmet>
      <Breadcrumb title={'Contact Us'} />
      {/*Forget Password section*/}
      <section className=' contact-page section-b-space'>
        <div className='container'>
          <div className='row section-b-space'>
            {/* <div className="col-lg-7 map">
							<iframe
								src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d50059.12775918716!2d72.78534673554945!3d21.16564923510817!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1533793756956"
								allowFullScreen
							/>
						</div> */}
            <div className='col-lg-6'>
              <div className='contact-right'>
                <ul>
                  <li>
                    <div className='contact-icon'>
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/icon/phone.png`}
                        alt='Generic placeholder image'
                      />
                      <h6>Contact Us</h6>
                    </div>
                    <div className='media-body'>
                      <p> 844 Eksplode</p>
                    </div>
                  </li>
                  <li>
                    <div className='contact-icon'>
                      <i className='fa fa-map-marker' aria-hidden='true' />
                      <h6>Address</h6>
                    </div>
                    <div className='media-body'>
                      <p>ABC Complex,Near xyz, New York</p>
                      <p>USA 123456</p>
                    </div>
                  </li>
                  <li>
                    <div className='contact-icon'>
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/icon/email.png`}
                        alt='Generic placeholder image'
                      />
                      <h6>Address</h6>
                    </div>
                    <div className='media-body'>
                      <p>support@eksplode.com</p>
                      <p>contact@eksplode.com</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className='col-md-6 mx-auto register-page section-a-space'>
              <div className='theme-card'>
                <form className='theme-form'>
                  <div className='box-head'>
                    <h3>Send us a message</h3>
                  </div>

                  <div className='form-row'>
                    <div className='col-12'>
                      <div className='form-group'>
                        <label htmlFor='name'> Name</label>
                        <input
                          type='text'
                          className='form-control mb-0'
                          id='name'
                          name='name'
                          placeholder='Name'
                          ref={register({
                            required: {
                              value: true,
                              message: 'This Field is Required',
                            },
                          })}
                        />
                        <label htmlFor='name' className='error'>
                          {errors.name && errors.name.message}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className='form-row'>
                    <div className='col-12'>
                      <div className='form-group'>
                        <label htmlFor='email'>Email</label>
                        <input
                          type='text'
                          className='form-control mb-0'
                          id='email'
                          name='email'
                          placeholder='Email'
                          ref={register({
                            required: {
                              value: true,
                              message: 'This Field is Required',
                            },
                            pattern: {
                              value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                              message: 'This must be a valid Email',
                            },
                          })}
                        />
                        <label htmlFor='email' className='error'>
                          {errors.email && errors.email.message}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className='form-row'>
                    <div className='col-12'>
                      <div className='form-group'>
                        <label htmlFor='message'>Message</label>
                        <textarea
                          type='text'
                          className='form-control mb-0'
                          id='message'
                          name='message'
                          placeholder='About the Product'
                          ref={register({
                            required: {
                              value: true,
                              message: 'This Field is Required',
                            },
                          })}
                          rows='6'
                        />
                        <label htmlFor='message' className='error'>
                          {errors.message && errors.message.message}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className='row justify-content-end'></div>
                </form>
                <button
                      className='btn btn-solid ml-auto'
                      onClick={handleSubmit(submitForm)}
                      disabled={isSubmitting} 
                    >
                      {isSubmitting ? 'Submitting...' : 'Submit'}
                    </button>
              </div>
            </div>
          </div>

          {/* <div className="row">
						<div className="col-sm-12">
							<form className="theme-form">
								<div className="form-row">
									<div className="col-md-6">
										<label htmlFor="first_name">
											First Name
										</label>
										<input
											type="text"
											className="form-control"
											id="fname"
											name="first_name"
											placeholder="First Name"
											ref={register({
												required: {
													value: true,
													message:
														"This Field is Required",
												},
											})}
										/>
										<label
											htmlFor="fname"
											className="error">
											{errors.first_name &&
												errors.first_name.message}
										</label>
									</div>
									<div className="col-md-6">
										<label htmlFor="email">Last Name</label>
										<input
											type="text"
											className="form-control"
											id="lname"
											name="last_name"
											placeholder="Last Name"
											ref={register({
												required: {
													value: true,
													message:
														"This Field is Required",
												},
											})}
										/>
										<label
											htmlFor="lname"
											className="error">
											{errors.last_name &&
												errors.last_name.message}
										</label>
									</div>
									<div className="col-md-6">
										<label htmlFor="phone">
											Phone number
										</label>
										<input
											type="text"
											className="form-control"
											id="review"
											name="phone"
											placeholder="Enter your Phone Number"
											ref={register({
												required: {
													value: true,
													message:
														"This Field is Required",
												},
												pattern: {
													value: /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i,
													message:
														"Enter a valid phone number",
												},
											})}
										/>
										<label
											htmlFor="lname"
											className="error">
											{errors.phone &&
												errors.phone.message}
										</label>
									</div>
									<div className="col-md-6">
										<label htmlFor="email">Email</label>
										<input
											type="text"
											className="form-control"
											id="email"
											name="email"
											placeholder="Email"
											ref={register({
												required: {
													value: true,
													message:
														"This Field is Required",
												},
												pattern: {
													value: /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/,
													message:
														"This must be a valid Email",
												},
											})}
										/>
										<label
											htmlFor="email"
											className="error">
											{errors.email &&
												errors.email.message}
										</label>
									</div>
									<div className="col-md-12">
										<label htmlFor="message">
											Write Your Message
										</label>
										<textarea
											className="form-control"
											placeholder="Write Your Message"
											id="exampleFormControlTextarea1"
											rows="6"
											name="message"
											ref={register({
												required: {
													value: true,
													message:
														"This field is required",
												},
											})}
										/>
										<label
											htmlFor="message"
											className="error">
											{errors.message &&
												errors.message.message}
										</label>
									</div>
									<div className="col-md-12">
										<button
											className="btn btn-solid"
											onClick={(e) => {
												handleSubmit(
													contactMessageHandler
												)(e);
												e.preventDefault();
											}}
											type="submit">
											Send Your Message
										</button>
									</div>
								</div>
							</form>
						</div>
					</div> */}
        </div>
      </section>
      {/* <div className='col-lg-3 mx-auto register-page section-b-space'>
              <div className='theme-card'>
                <form className='theme-form'>
				<div className='col-md-6'>
                    <div className='form-group'>
                      <label htmlFor='product_name'>Product Name</label>
                      <input
                        type='text'
                        className='form-control mb-0'
                        id='product_name'
                        name='product_name'
                        placeholder='Product Name'
                        ref={register({
                          required: {
                            value: true,
                            message: 'This Field is Required',
                          },
                        })}
                      />
                      <label htmlFor='product_name' className='error'>
                        {errors.product_name && errors.product_name.message}
                      </label>
                    </div>
                  </div>
				</form>
              </div>
            </div> */}
    </div>
  )
}

export default Contact
